import {
  Component,
  ComponentRef,
  Input,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import { NcsMsgboxComponent } from '../components/ncs-msgbox/ncs-msgbox.component';

declare var bootstrap: any;

@Component({
  selector: 'app-uiform-create',
  templateUrl: './uiform-create.component.html',
  styleUrls: ['./uiform-create.component.scss'],
})
export class UiformCreateComponent extends BaseListCtl {
  /**
   * ID of the application to which this form belongs.
   */
  public appId: number = 0;
  public applogo: number = 0;
  public appName: String = '';
  public usecaseId: number = 0;
  public selectedButton: any = 0;
  public selectedItemId: any;
  public selectedEvent: any;
  public selectParent: any;
  public selectedChildUsecase: any;
  public selectedChildForm: any = undefined;
  public selectChildList: any;
  public selectChildFormList: any;
  public isArchivedlistTabActive: boolean = false;
  public isTrashTabActive: boolean = false;
  public formId: number = 0;
  public isExpanded: boolean[] = [];
  @ViewChild('messageBoxContainer', { read: ViewContainerRef, static: true })
  messageBoxContainer!: ViewContainerRef;

  messageBoxRef!: ComponentRef<NcsMsgboxComponent>;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
  ) {
    super('', locator, route);
    let _self = this;
    _self.usecaseId = Number(route.snapshot.paramMap.get('usecaseId'));
    _self.form['userstoryId'] = _self.usecaseId;
    _self.export = {
      excel: true,
      pdf: true,
      print: false,
      copy: false,
      filter: false,
    };
    _self.form['isConfirmDelete'] = false;
    _self.form['data'] = {};
    _self.form['data']['description'] = '';
    _self.form['data']['columns'] = 1;
    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
    this.form.data['readOnly'] = false;
  }

  override async populateForm(form: any, data: any) {
    form.id = data.id;
    form.title = data.title;
    form.subtitle = data.subtitle;
    form.description = data.description;
    form.userstoryId = data.userstoryId;
    form.code = data.code;
    if (!data.columns) {
      data.columns = 1;
    }
    form.columns = data.columns;
    form.fields = data.fields;
    form.childFormList = data.childFormList;
    form.groupLabels = data.groupLabels;
    form.inputs = data.inputs;
    form.readOnly = data.readOnly;
    if (data.buttons) {
      form.buttons = data.buttons;
    } else {
      form.buttons = [];
    }

    if (data.rules) {
      form.rules = data.rules;
    }

    this.setColumns();
    this.appId = data.applicationId;
    this.getRules1();
  }

  override ngOnInit() {
    this.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        this.preload();
        this.search();
        this.searchArchived();
        this.searchTrash();
        this.display();
        this.getUsecaseAttributes();
        this.getUsecaseDataList();
      });
  }

  selectedChild(usecaseId: any, callback?: any) {
    let _self = this;
    if (usecaseId === 'undefined') {
      _self.selectChildFormList = [];
      _self.selectedChildForm = undefined;
      return;
    }

    let searchParams: any = {};
    _self.form.searchError = false;
    _self.form.searchMessage = '';
    searchParams['userstoryId'] = Number(usecaseId);

    this.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        let url = property + '/searchform/' + 0;
        searchParams['pageSize'] = 100;
        this.locator.http.post(
          url,
          searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }
              return;
            }
            if (res.success) {
              _self.selectChildFormList = res.result.data;

              if (callback) {
                callback();
              }
            }
            if (callback) {
              callback();
            }
          },
        );
      });
  }

  /**
   * Searhs records
   */
  override search(callback?: any) {
    var _self = this;
    _self.form.searchError = false;
    _self.form.searchMessage = '';
    _self.form.searchParams['userstoryId'] = _self.usecaseId;

    this.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        let url = property + '/searchform/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.list = res.result.data || [];
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              //Check empty list
              if (_self.form.list.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              // Add data in Datatable
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            } else {
              _self.form.list = [];
            }

            if (callback) {
              callback();
            }
          },
        );
      });
  }

  async searchArchived(callback?: any) {
    var _self = this;
    _self.form.searchError = false;
    _self.form.searchMessage = '';

    this.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        let url = property + '/searchArchived/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.archivedlist = [];
              setTimeout(() => {
                _self.form.archivedlist = res.result.data || [];
              }, 0);
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              //Check empty list
              if (_self.form.archivedlist.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              // Add data in Datatable
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            } else {
              _self.form.archivedlist = [];
            }

            if (callback) {
              callback();
            }
          },
        );
      });
  }

  /**
   * Get list of archived data
   * @param callback
   */
  searchTrash(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';

    this.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        let url = property + '/searchTrash/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              // ✅ Force change detection by clearing first
              _self.form.trashlist = [];
              setTimeout(() => {
                _self.form.trashlist = res.result.data || [];
              }, 0);

              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = res.result.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              if (_self.form.trashlist.length === 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              if (callback) {
                callback();
              }
            } else {
              _self.form.trashlist = [];
              if (callback) {
                callback();
              }
            }
          },
        );
      });
  }

  /**
   * Restore the archived data
   * @param id
   */
  toggleTab(tab: string): void {
    this.isArchivedlistTabActive = tab === 'archivedlist';
    this.isTrashTabActive = tab === 'trashlist';
    if (this.isTrashTabActive) {
      this.isArchivedlistTabActive = true;
    }
  }

  ruleList: any;

  getRules(): void {
    let _self = this;
    let searchData = {
      formId: _self.formId,
    };

    _self.locator.config
      .getProperty('endpoint.application.rules')
      .then((property: string) => {
        let url = property + '/search/0';

        _self.locator.http.post(
          url,
          searchData,
          function (res: any, error: boolean) {
            if (error) {
              alert('Server Error:' + error);
              return;
            }

            _self.ruleList = res.result?.data || [];
            const onAddMap = new Map<number, string>();
            const currentFormId = _self.formId;

            _self.ruleList.forEach((rule: any) => {
              const formId = rule.formId;
              const isOnAdd = rule.event === 'onAdd';

              if (!onAddMap.has(formId)) {
                onAddMap.set(formId, isOnAdd ? 'Yes' : 'No');
              } else if (isOnAdd) {
                onAddMap.set(formId, 'Yes');
              }
            });

            const keySuffix = localStorage.getItem('keySuffix');
            let existingData = localStorage.getItem(keySuffix + 'ruleData');
            let ruleData: { [key: number]: string } = existingData
              ? JSON.parse(existingData)
              : {};

            if (onAddMap.has(currentFormId)) {
              ruleData[currentFormId] = onAddMap.get(currentFormId)!;
            } else {
              delete ruleData[currentFormId];
            }

            localStorage.setItem(
              keySuffix + 'ruleData',
              JSON.stringify(ruleData),
            );
          },
        );
      });
  }

  ruleList1: any;
  getRules1(): void {
    let _self = this;

    let searchData = {
      appId: Number(this.appId),
    };
    _self.locator.config
      .getProperty('endpoint.application.rules')
      .then((property: string) => {
        let url = property + '/search/0';
        _self.locator.http.post(
          url,
          searchData,
          function (res: any, error: boolean) {
            if (error) {
              alert('Server Error:' + error);
              return;
            }
            _self.ruleList1 = res.result['data'];
          },
        );
      });
  }
  getDetails(rule_value?: any) {
    if (!this.ruleList || !Array.isArray(this.ruleList)) {
      return null;
    }
    const selectedRule = this.ruleList.find(
      (rule: any) => rule && rule.id === +rule_value,
    );
    return selectedRule ? selectedRule.rule : null;
  }

  updateFormField(field: string, event: any, rule_value?: any) {
    let _self = this;

    const selectedRule = this.ruleList.find(
      (rule: any) => rule.id === +rule_value,
    );

    _self.form.data[field] = _self.form.data[field] || {};
    _self.form.data[field][event] = {
      rule: selectedRule?.name,
      id: selectedRule?.id,
    };
    _self.save();
  }

  getRuleKeys(): string[] {
    return this.form?.data?.rules ? Object.keys(this.form.data.rules) : [];
  }

  onDeleteRules(key: string) {
    let _self = this;
    delete _self.form.data['rules'][key]; // Remove the rule from the object
    _self.save();
  }

  ngAfterViewInit(): void {
    // Initialize Bootstrap tooltips
    const tooltipTriggerList = [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }

  override resetForm() {
    super.resetForm();
    let _self = this;
    this.form.data['userstoryId'] = _self.usecaseId;
    this.form.data['readOnly'] = false;
    this.selectedEditItemId = null;
  }

  override async save() {
    let _self = this;
    this.form.data['userstoryId'] = _self.usecaseId;
    this.form.data['applicationId'] = _self.appId;
    super.save();
  }

  gotoForm(apiId: number) {
    let _self = this;
    this.formId = apiId;
    _self.getRules();
    this.forward('uiformlist/' + apiId);
  }

  setSelectedItem(id: any) {
    this.selectedItemId = id;
    this.messageBoxContainer.clear();
    this.messageBoxRef =
      this.messageBoxContainer.createComponent(NcsMsgboxComponent);
    this.messageBoxRef.instance.title = 'Delete Item';
    this.messageBoxRef.instance.message =
      'Are you sure you want to delete this item?';
    this.messageBoxRef.instance.onOk.subscribe(() => this.confirmDelete());
  }

  getColum(field: any) {
    if (field['colsize']) {
      return 12 / field['colsize'];
    }
    return 12;
  }

  isShowRowSpan(fieldId: number) {
    return this.usecaseAttributes.find(
      (attr: any) => attr.id === fieldId && attr['type'] == 'textarea',
    );
  }

  onRowSizeChange(ind: number, event: any) {
    let _self = this;
    let value = event.target.value;
    if (/^[0-9]*$/.test(value)) {
      _self.form.data['fields'][ind]['rowsize'] = value;
      this.save();
    } else {
      alert('value is not a valid number');
      return;
    }
  }

  onColSizeChange(ind: number, event: any) {
    let _self = this;
    let value = event.target.value;
    if (/^[0-9]*$/.test(value)) {
      if (value == 0 || value > _self.form.data.columns) {
        alert(
          'value is not a valid it between 1 to ' + _self.form.data.columns,
        );
        this.getDefaultValue(_self.form.data.columns);
        event.target.value = _self.form.data.columns;
        return;
      }
      _self.form.data['fields'][ind]['colsize'] = value;
      this.save();
    } else {
      alert('value is not a valid number');
      return;
    }
  }

  getDefaultValue(value: any) {
    if (/^[0-9]*$/.test(value) && value > 0) {
      return value;
    }
    return 1;
  }

  override preload(): void {}

  public usecase: any = [];

  display() {
    let _self = this;
    let url =
      this.locator.config.get('endpoint.userstory') + '/get/' + _self.usecaseId;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      _self.usecase = res.result.data;
      _self.appName = res.result.data.appName;
      _self.appId = _self.usecase.appId;

      if (!_self.form.data) {
        _self.form.data = {};
      }

      if (!_self.form.data.childFormList) {
        _self.form.data.childFormList = [];
      }

      if (res.result.data['appId'] > 0) {
        _self.getAppDetails(res.result.data['appId']);
        _self.getChildUscase();
      }
    });
  }

  getAppDetails(appId: any) {
    let _self = this;
    let url = this.locator.config.get('endpoint.application') + '/get/' + appId;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.appName = res.result.data['name'];
      _self.applogo = res.result.data['logo'];
    });
  }

  /**
   * Contains usecase attributes
   */
  public usecaseAttributes: any = [];

  /**
   * Get usecase attributes
   * @param id
   */
  getUsecaseAttributes() {
    let _self = this;
    let tempformList: any[] = [];
    let tempattrList = [];
    let url =
      this.locator.config.get('endpoint.ui.forms') +
      '/attributes/' +
      _self.usecaseId;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      tempformList = res.result.data;

      let attrUrl =
        _self.locator.config.get('endpoint.userstory.attributes') +
        '/list/' +
        _self.usecaseId;
      _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
        tempattrList = res.result.data;
        const filteredAttributes = tempattrList.filter(
          (attr: any) => attr?.system !== 1,
        );

        // Match and collect usecase attributes
        const matchedAttributes = tempformList.filter((form: any) =>
          filteredAttributes.some((attr: any) => attr.id === form.id),
        );

        _self.usecaseAttributes = matchedAttributes
          .filter((e) => e['type'] != 'tag')
          .filter((item: any) => item?.disable != 1);       
        _self.showUsecaseAttributes = _self.usecaseAttributes;
      });
    });
  }

  getAttributeById(fieldId: number) {
    return this.usecaseAttributes.find(
      (attr: any) => attr.id === fieldId && attr['system'] != 1,
    );
  }

  public editForm(id: number) {
    let _self = this;
    super.get(id, function cb() {
      _self.getUsecaseAttributes();
    });
  }

  public selectedField: any = null;

  public setCurrentField(ele: any) {
    this.selectedField = ele;
  }

  getDependenceField(ele: string) {
    let _self = this;
    for (let i = 0; i < _self.usecaseAttributes.length; i++) {}
  }

  addField(ele: string) {
    let _self = this;
    if (!ele) {
      alert('Please select field');
      return;
    }
    if (!_self.form.data['fields']) {
      _self.form.data['fields'] = [];
    }
    const exists = _self.form.data['fields'].some(
      (field: any) => field.id === parseInt(ele),
    );
    if (!exists) {
      let item = {
        id: 0,
        label: '',
      };
      for (let i = 0; i < _self.usecaseAttributes.length; i++) {
        item = _self.usecaseAttributes[i];

        if (item.id === parseInt(ele)) {
          _self.form.data['fields'].push(item);
          // check dependence attributes exist ;
          // if(_self.usecaseAttributes[i]['depAttribute']){
          //   let dep_item = {
          //     id: 0,
          //     label: ""
          //   };
          //   dep_item =_self.usecaseAttributes.some((attribute: any) => attribute.code === _self.usecaseAttributes[i]['depAttribute']);
          //   _self.form.data["fields"].push(dep_item);
          // }
          // add dependent field
          _self.save();

          // Reset the select dropdown to "--Input Fields--"
          setTimeout(() => {
            let fieldSelect = document.getElementById(
              'usecaseAttribute',
            ) as HTMLSelectElement;
            if (fieldSelect) {
              fieldSelect.value = 'undefined';
            }
          }, 0);
        }
      }
    } else {
      alert('field already exist');
    }
  }

  removeField(ele: any) {
    let _self = this;

    // 1. Find the field object using its ID
    const fieldObj = _self.form.data['fields'].find(
      (field: any) => field.id === parseInt(ele),
    );

    if (!fieldObj) {
      alert('Field not found.');
      return;
    }
    const fieldName = fieldObj.code;

    this.getUsecaseDataList(() => {
      const isFieldInUse = _self.usecaseData.some(
        (record: any, index: number) => {
          return (
            record.hasOwnProperty(fieldName) &&
            record[fieldName] !== null &&
            record[fieldName] !== undefined &&
            record[fieldName] !== ''
          );
        },
      );

      if (isFieldInUse) {
        alert('This field contains data,so it can not be removed.');
        return;
      }

      const confirmDelete = confirm(
        'Are you sure you want to remove this field?',
      );
      if (!confirmDelete) {
        return;
      }

      _self.form.data['fields'] = _self.form.data['fields'].filter(
        (field: any) => field.id !== parseInt(ele),
      );

      _self.save();
    });
  }

  searchValues: any = {};
  @Input() usecaseData = [];
  public apiurl: string = '';

  public getUsecaseDataList(callback?: any) {
    let _self = this;

    let updatedName;
    if (_self.usecase['collectionName']) {
      updatedName = _self.usecase['collectionName'].replace(/\./g, '/');
    }
    _self.apiurl =
      _self.locator.config.get('endpoint.api.v1') + '/' + updatedName;
    let url = _self.apiurl + '/search';
    if (_self.is_paging) {
      url = _self.apiurl + '/search/' + _self.form.pageNo;
    }

    _self.locator.http.post(
      url,
      _self.getSearchCriteria(),
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.usecaseData = res.result['data'];
        _self.form.pageCount = res.result.pageCount;
        _self.form.pageSize = res.result.pageSize;
        _self.form.pageNos = _self.form.pageNo;
        _self.form.pageNoList = [];
        for (let i = 0; i < _self.form.pageCount; i++) {
          _self.form.pageNoList.push(i);
        }
        if (_self.usecaseData.length == 0) {
          _self.form.message = 'No record found';
          _self.form.error = true;
        }
        if (callback) {
          callback();
        }

        // _self.processData();
      },
    );
  }

  public getSearchCriteria() {
    let searchdata = Object.fromEntries(
      Object.entries(this.searchValues).filter(
        ([_, value]) => value !== null && !Number.isNaN(value) && value !== '',
      ),
    );

    searchdata = this.setSearchData(searchdata);
    return searchdata;
  }

  /**
   * Move element up or down
   * @param ind
   * @param move
   */
  move(ind: number, move: string) {
    let _self = this;

    if ('up' == move && ind > 0) {
      let moveIndex = ind - 1;
      // Swap elements
      let temp = _self.form.data['fields'][ind];
      _self.form.data['fields'][ind] = _self.form.data['fields'][moveIndex];
      _self.form.data['fields'][moveIndex] = temp;
    }

    if ('down' == move && ind + 1 < _self.form.data['fields'].length) {
      let moveIndex = ind + 1;
      let temp = _self.form.data['fields'][ind];
      _self.form.data['fields'][ind] = _self.form.data['fields'][moveIndex];
      _self.form.data['fields'][moveIndex] = temp;
    }

    //Reindexing
    for (let i = 0; i < _self.form.data['fields'].length; i++) {
      _self.form.data['fields'][i]['index'] = i + 1;
    }

    _self.save();
  }

  /**
   * Move field before another field
   *
   * @param ind
   * @param beforeInd
   */
  moveBefore(ind: number, beforeInd: string) {
    let _self = this;

    // Remove the element from the original position
    const element = _self.form.data['fields'].splice(ind, 1)[0];

    // Insert the element at the new position
    _self.form.data['fields'].splice(beforeInd, 0, element);

    //Reindexing
    for (let i = 0; i < _self.form.data['fields'].length; i++) {
      _self.form.data['fields'][i]['index'] = i + 1;
    }
  }

  public cols = 4;

  public setColumns() {
    let _self = this;
    if (_self.form.data['columns']) {
      _self.cols = 12 / _self.form.data['columns'];
    }
  }

 addSelectedButtons() {
    let _self = this;

    if (_self.selectedButton == '0') {
      return;
    }
    if (!_self.form.data.buttons || !Array.isArray(_self.form.data.buttons)) {
      _self.form.data.buttons = []; 
    }

    let buttonName = _self.selectedButton;

    const exists = _self.form.data.buttons.find(
      (button: any) => button.name === buttonName,
    );

    if (!exists) {
      _self.form.data.buttons.push({
        name: buttonName,
        url: '@',        
        type: 'system',
      });
    }
    _self.save();
    setTimeout(() => {
      _self.selectedButton = '0';
    }, 0);  
  }

  onRemoveButton(buttonKey: string, event: any) {
    delete this.form.data.buttons[buttonKey];
    this.save();
  }

  moveButton(index: number, direction: 'up' | 'down') {
    let _self = this;
    let buttons = _self.form.data.buttons;
    if (direction === 'up' && index > 0) {
      [_self.form.data.buttons[index - 1], _self.form.data.buttons[index]] = [
        _self.form.data.buttons[index],
        _self.form.data.buttons[index - 1],
      ];
    } else if (direction === 'down' && index < buttons.length - 1) {
      [_self.form.data.buttons[index + 1], _self.form.data.buttons[index]] = [
        _self.form.data.buttons[index],
        _self.form.data.buttons[index + 1],
      ];
    }

    _self.save();
  }

  removeButton(ele: any) {
    let _self = this;
    if (_self.form.data['buttons']) {
      // Use filter to create a new array without the element having the matching id
      _self.form.data['buttons'] = _self.form.data['buttons'].filter(
        (button: any) => button.name !== ele,
      );
    }
    _self.save();
  }

  moveInputButton(index: number, direction: 'up' | 'down') {
    let _self = this;
    let inputs = _self.form.data.inputs;
    if (direction === 'up' && index > 0) {
      [_self.form.data.inputs[index - 1], _self.form.data.inputs[index]] = [
        _self.form.data.inputs[index],
        _self.form.data.inputs[index - 1],
      ];
    } else if (direction === 'down' && index < inputs.length - 1) {
      [_self.form.data.inputs[index + 1], _self.form.data.inputs[index]] = [
        _self.form.data.inputs[index],
        _self.form.data.inputs[index + 1],
      ];
    }

    _self.save();
  }

  removeInputButton(ele: any) {
    let _self = this;

    let flag = confirm('Are you sure ?');
    if (!flag) {
      return;
    }

    if (_self.form.data['inputs']) {
      // Use filter to create a new array without the element having the matching id
      _self.form.data['inputs'] = _self.form.data['inputs'].filter(
        (field: any) => field.id !== parseInt(ele),
      );
    }
    _self.save();
  }

  onSpanChange(ind: number, type: any, event: any) {
    let _self = this;
    let value = event.target.value;
    if (/^[0-9]*$/.test(value)) {
      _self.form.data['fields'][ind][type] = value;

      this.save();
    } else {
      alert('value is not a valid number');
      return;
    }
  }

  // getButtonClass(buttonKey: string) {
  //   const button_class: { [key: string]: string } = {
  //     save: 'btn btn-sm btn-outline-primary ms-2',
  //     cancel: 'btn btn-sm btn-outline-secondary ms-2',
  //     delete: 'btn btn-sm btn-outline-danger ms-2',
  //     list: 'btn btn-sm btn-outline-primary ms-2',
  //     new: 'btn btn-sm btn-outline-primary ms-2',
  //   };
  //   return button_class[buttonKey] || 'btn btn-sm btn-outline-primary ms-2';
  // }
  getButtonColor(buttonKey: string): 'primary' | 'accent' | 'warn' {
    switch (buttonKey) {
      case 'delete':
        return 'warn';
      case 'cancel':
        return 'warn';
      default:
        return 'primary';
    }
  }

  addInput(ele: string) {
    let _self = this;
    if (!_self.form.data['inputs']) {
      _self.form.data['inputs'] = [];
    }
    const exists = _self.form.data['inputs'].some(
      (field: any) => field.id === parseInt(ele),
    );
    if (!exists) {
      let item = {
        id: 0,
        label: '',
      };
      for (let i = 0; i < _self.usecaseAttributes.length; i++) {
        item = _self.usecaseAttributes[i];

        if (item.id === parseInt(ele)) {
          _self.form.data['inputs'].push(item);

          // check dependence attributes exist ;
          // if(_self.usecaseAttributes[i]['depAttribute']){
          //   let dep_item = {
          //     id: 0,
          //     label: ""
          //   };
          //   dep_item =_self.usecaseAttributes.some((attribute: any) => attribute.code === _self.usecaseAttributes[i]['depAttribute']);
          //   _self.form.data["fields"].push(dep_item);
          // }
          // add dependent field
          _self.save();
        }
      }
    } else {
      alert('Inputs already exist');
    }
  }

  removeInput(ele: any) {
    let _self = this;
    if (_self.form.data['inputs']) {
      // Use filter to create a new array without the element having the matching id
      _self.form.data['inputs'] = _self.form.data['inputs'].filter(
        (field: any) => field.id !== parseInt(ele),
      );
    }
    _self.save();
  }

  onMoveButton(buttonKey: string, event: any) {}

  async confirmDelete() {
    await this.delete(this.selectedItemId);
  }

  override async delete(id: number, callback?: any): Promise<void> {
    try {
      await super.delete(id);

      this.form.archivedlist = this.form.archivedlist.filter(
        (item: any) => item.id !== id,
      );
      await this.searchTrash();
      // await this.searchArchived();

      if (callback) callback();
    } catch (error) {
      console.error(
        'Error occurred while deleting and searching archived:',
        error,
      );
      if (callback) callback(error);
    }
    this.form.archivedlist = this.form.archivedlist.filter(
      (item: any) => item.id !== id,
    );
  }

  getButtonIcon(buttonKey: string): string {
    const icons: { [key: string]: string } = {
      save: 'fas fa-save me-1 fs-6',
      cancel: 'fas fa-times me-1 fs-6',
      delete: 'bx bxs-trash me-1 fs-6',
      list: 'fas fa-list me-1 fs-6',
      new: 'fa fa-plus me-1 fs-6',
    };
    return icons[buttonKey] || 'fa fa-invisible';
  }

  // Add this method for Material icons
  getMaterialButtonIcon(buttonKey: string): string {
    const icons: { [key: string]: string } = {
      save: 'save',
      cancel: 'close',
      delete: 'delete',
      list: 'list',
      new: 'add',
      custom: 'edit',
    };
    return icons[buttonKey] || 'settings'; // Default fallback icon
  }

  // Method to get the button label based on the key
  getButtonLabel(buttonKey: string): string {
    const labels: { [key: string]: string } = {
      save: 'COMMON.SAVE',
      cancel: 'COMMON.CANCEL',
      delete: 'COMMON.DELETE',
      list: 'COMMON.LIST',
      new: 'COMMON.NEW',
    };   
    return labels[buttonKey] || buttonKey;
  }

  public getInputType(t: string) {
    if (t === 'date') {
      return t;
    } else if (t === 'number' || t === 'decimal') {
      return 'number';
    }
    if (t === 'text') {
      return 'text';
    }
    if (t === 'date') {
      return t;
    }
    if (t === 'time') {
      return t;
    }
    if (t === 'file') {
      return t;
    } else {
      return 'text';
    }
  }

  //----------------------------------------------------------------------------------------------------

  /**
   * Adds or toggles the form display status on the dashboard.
   * @param id
   * @param callback -
   */
  async addDashboard(id: any, callback?: any) {
    let _self = this;
    // Check if the ID is valid (non-null and non-zero).
    if (!id || id == 0) {
      if (callback) {
        callback();
      }
      return;
    }
    this.locator.config
      .getProperty(_self.api.endpoint)
      .then((property: string) => {
        let url = _self.api.get + '/' + id;
        this.locator.http.get(url, async function (res: any, error: any) {
          if (error) {
            return;
          }
          _self.form.error = !res.success;
          _self.form.message = res.result.message;

          if (res.success) {
            _self.form.data.id = id;
            // Use a default value of 0 if 'showDashboard' is undefined
            const isDashboardVisible = res.result.data['showDashboard'] ?? 0;
            await _self.populateForm(_self.form.data, res.result.data);
            // Access the current 'showDashboard' status from the form data.
            // Toggle 'showDashboard': set to 1 if it's currently 0, or to 0 if it's 1.
            // - If it's null or 0 (not displayed), set it to 1 (visible).
            // - If it's 1 (visible), set it to 0 (not displayed).
            _self.form.data['showDashboard'] = isDashboardVisible === 0 ? 1 : 0;
            _self.save();
            if (callback) {
              callback();
            }
          }
        });
      });
  }

  addEvent(index: any, e: any) {
    let _self = this;
    if (e.event == undefined || e.event == 'undefined') {
      alert('Remove');
      delete _self.form.data['fields'][index]['event'];
      _self.save();
      return;
    } else {
      _self.form.data['fields'][index]['event'] = e['event'];
      _self.save();
    }
  }

  addEventRule(index: any, e: any) {
    let _self = this;
    if (e.rule == undefined || e.rule == 'undefined') {
      alert('Remove');
      delete _self.form.data['fields'][index]['rule'];
      _self.save();
      return;
    } else {
      _self.form.data['fields'][index]['rule'] = e['rule'];
      _self.save();
    }
  }

  addFeild(index: any, e: any, field: any) {
    let _self = this;
    try {
      e.trim();
      _self.form.data['fields'][index][field] = e;
      _self.save();
    } catch (error) {
      console.error(`Error processing value for e: ${e}`, error);
    }
  }

  // Helper function to validate the value of e
  isValidExpression(expression: any): boolean {
    // Check if the value is a boolean, since expressions like `studentId > 0` resolve to true/false
    if (typeof expression === 'boolean') {
      return true;
    }
    // If it's not a boolean, consider it invalid
    return false;
  }

  public groupLabel: String = '';
  public setLabel: String = '';
  public groupIndex: any = 0;

  temp() {
    let _self = this;
    _self.form.data['groupLabels'] = [];
    _self.save();
  }

  resetGroup() {
    this.groupLabel = '';
  }

  /**
   * Add new label in groupLabels
   * @returns
   */
  addGroup() {
    const _self = this;
    _self.form.message = '';
    _self.form.error = false;

    // Validate `groupLabel`
    if (!_self.groupLabel || typeof _self.groupLabel !== 'string') {
      _self.form.inputerror['groupLabel'] = 'Label cannot be empty';
      console.warn('Invalid label input. Cannot add.');
      return;
    }

    // Ensure `groupLabels` exists
    if (!_self.form.data?.groupLabels) {
      _self.form.data.groupLabels = [];
    }

    // Check for duplicate label
    const isDuplicate = _self.form.data.groupLabels.some(
      (item: { label: string }) =>
        item.label.toLowerCase() === _self.groupLabel.toLowerCase(),
    );

    if (isDuplicate) {
      _self.form.inputerror['groupLabel'] = 'Duplicate label cannot be added';
      console.warn('Duplicate label. Cannot add.');
      return;
    }

    // Add new label if not a duplicate
    _self.form.data.groupLabels.push({
      index: _self.form.data.groupLabels.length,
      label: _self.groupLabel,
      allowedTimeStart: null,
      allowedTimeEnd: null,
      allowedTimeStartMeridian: null,
      allowedTimeEndMeridian: null,
    });

    // Save the updated data
    _self.save();
  }

  invalidTimeMsg: string | null = null;

  onTimeChange(section: any, index: number, type: 'start' | 'end'): void {
    const value =
      type === 'start' ? section.allowedTimeStart : section.allowedTimeEnd;
    const isValid = /^(0[0-9]|1[0-2]):[0-5][0-9]$/.test(value);
    if (!isValid) {
      this.invalidTimeMsg =
        'Invalid time format! Please enter time as hh:mm in 12-hour format (01:00 to 12:59).';
      if (type === 'start') section.allowedTimeStart = null;
      else {
        section.allowedTimeEnd = null;
      }
      setTimeout(() => {
        this.invalidTimeMsg = null; // Hide after 4 seconds
      }, 4000);

      return; // Stop saving if invalid
    }

    this.save();
  }

  onMeridianChange(
    section: any,
    index: number,
    type: 'start' | 'end',
    value: any,
  ): void {
    // If selected value is null or empty, reset the corresponding time
    if (!value) {
      if (type === 'start') {
        section.allowedTimeStart = null;
        section.allowedTimeStartMeridian = null;
      } else {
        section.allowedTimeEnd = null;
        section.allowedTimeEndMeridian = null;
      }
      this.save();
      return;
    }
    if (type === 'start') {
      section.allowedTimeStartMeridian = value;
      if (section.allowedTimeStart) {
        const isValidStart = /^(0[0-9]|1[0-2]):[0-5][0-9]$/.test(
          section.allowedTimeStart,
        );
        if (!isValidStart) {
          alert('Resetting time to empty.');
          section.allowedTimeStart = null;
        }
      }
    } else {
      section.allowedTimeEndMeridian = value;
      if (section.allowedTimeEnd) {
        const isValidEnd = /^(0[0-9]|1[0-2]):[0-5][0-9]$/.test(
          section.allowedTimeEnd,
        );
        if (!isValidEnd) {
          alert('Resetting time to empty.');
          section.allowedTimeEnd = null;
        }
      }
    }
    this.save();
  }

  // onTimeChange(section: any, index: number, type: 'start' | 'end', value: any): void {
  //   if (type === 'start') {
  //     section.allowedTimeStart = value;
  //   } else {
  //     section.allowedTimeEnd = value;
  //   }

  //   // Save updated form
  //   this.save();
  // }

  hours: number[] = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24,
  ];

  /**
   * delete group from table
   */
  async deleteGroup(label: any, index: any) {
    let _self = this;
    const confirmAsync = () =>
      new Promise((resolve) => {
        const flag = confirm('Are you sure ?');
        resolve(flag);
      });

    const flag = await confirmAsync();
    if (!flag) {
      return;
    }

    if (
      _self.form.data['groupLabels'] &&
      _self.form.data['groupLabels'].length
    ) {
      for (let idx = 0; idx < _self.form.data.fields.length; idx++) {
        const field = _self.form.data.fields[idx];
        if (field?.group === label) {
          alert('Cannot be deleted as it exists in another field');
          return;
        }
      }

      // Remove the group label and save changes asynchronously
      _self.form.data['groupLabels'].splice(index, 1);

      if (_self.save && typeof _self.save === 'function') {
        try {
          _self.save(); // Ensure save is awaited
          console.log('Group label deleted and changes saved successfully.');
        } catch (error) {
          console.error('Error saving changes:', error);
        }
      }
    }
  }

  /**
   * Add Section into fields
   */
  // public async addGroupAtt(event: any, index: any) {
  //   let _self = this;
  //   let value: any = event.target.value;

  //   try {
  //     if (value === 'null' || value === 'undefined') {
  //       alert('Remove');
  //       delete _self.form.data['fields'][index]['group']; // Removes the 'group' property
  //       _self.save();
  //       return;
  //     }

  //     if (_self.form.data['fields'] && _self.form.data['fields'][index]) {
  //       _self.form.data['fields'][index]['group'] = value;
  //     } else {
  //       console.error('Invalid fields or index');
  //     }

  //     _self.save();
  //   } catch (error) {
  //     console.error(`Error processing value: ${value}`, error);
  //   }
  // }

  public async addGroupAtt(event: any, index: number) {
    // Extract value (Material uses event.value)
    let value: any =
      event.value !== undefined ? event.value : event?.target?.value;

    try {
      if (
        value === null ||
        value === undefined ||
        value === 'null' ||
        value === 'undefined'
      ) {
        alert('Remove'); // <--- Restored your alert here

        if (this.form.data['fields'][index]) {
          delete this.form.data['fields'][index]['group'];
        }
        await this.save();
        return;
      }

      if (this.form.data['fields'] && this.form.data['fields'][index]) {
        this.form.data['fields'][index]['group'] = value;
        await this.save();
      }
    } catch (error) {
      console.error(`Error:`, error);
    }
  }
  /**
   * Usecase name input check and correction
   * @param event
   */
  checkUsecaseName(event: Event): void {
    const input = event.target as HTMLInputElement; // Cast event target as input element
    const regex = /^[a-zA-Z0-9]+( [a-zA-Z0-9]+)?$/;
    const value = input.value.trim(); // Get the input value and trim leading/trailing spaces
    const clearVAlue = value.replace(/[^a-zA-Z0-9 ]*/g, '');
    this.form.data['title'] = this.capitalizeUsecaseWords(
      this.normalizeSpaces(clearVAlue),
    );
  }

  /**
   * Normalize spaces in a string to ensure only one space between words.
   * @param str - Input string to normalize.
   * @returns Normalized string with single spaces.
   */
  normalizeSpaces(str: string): string {
    return str.replace(/\s+/g, ' '); // Replace multiple spaces with a single space
  }

  capitalizeUsecaseWords(str: string): string {
    return str
      .split(' ') // Split the string by spaces
      .map(
        (word) =>
          word === word.toUpperCase() // Check if all characters are uppercase
            ? word // Keep the word as is if all characters are uppercase
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(), // Otherwise, capitalize the first letter
      )
      .join(' '); // Join the array back into a string with spaces
  }

  public filterParentList(): any {
    return this.form.list.filter((e: any) => e['id'] != this.form.data['id']);
  }

  /**
   * Retrieve a record and execute callback after deletion
   *
   * @param id
   * @param callback
   */
  async retrieve(id: any, callback?: any) {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    _self.form.isConfirmDelete = true;
    if (id && id > 0) {
      if (_self.form.isConfirmDelete) {
        let flag = confirm('Are you sure ?');
        if (!flag) {
          return;
        }

        let url =
          this.locator.config.get('endpoint.ui.forms') + '/retrieve/' + id;
        this.locator.http.get(url, async function (res: any, error: any) {
          if (error) {
            return;
          }
          _self.form.error = !res.success;
          _self.form.message = res.result.message;
          if (res.success) {
            _self.form.message = 'Data is retrieved';
            _self.searchArchived();
            _self.searchTrash();
            _self.search();
            _self.form.trashlist = _self.form.trashlist.filter(
              (item: any) => item.id !== id,
            );
            _self.form.archivedlist = _self.form.archivedlist.filter(
              (item: any) => item.id !== id,
            );

            if (callback) {
              callback(res, error);
            }
          }
        });
      }
    }
  }

  ischecked(value: any): boolean {
    // Return true if value is undefined or null, otherwise false
    return value === undefined || value === null;
  }

  // checkbox(event: Event, index: any) {
  //   const checked = (event?.target as HTMLInputElement)?.checked; // Type assertion for better type safety
  //   if (checked) {
  //     delete this.form.data['fields'][index]['listView'];
  //     this.save();
  //   } else {
  //     this.form.data['fields'][index]['listView'] = 1;
  //     this.save();
  //   }
  // }
  checkbox(event: any, index: number) {
    // Logic: Material uses event.checked, Native uses event.target.checked
    const isChecked =
      event.checked !== undefined
        ? event.checked
        : (event?.target as HTMLInputElement)?.checked;

    if (isChecked) {
      // If user checks the box
      delete this.form.data['fields'][index]['listView'];
    } else {
      // If user unchecks the box
      this.form.data['fields'][index]['listView'] = 1;
    }

    this.save();
  }

  /**
   * Find the Parent usecase
   * @param index
   * @param e
   */
  parentFilters(index: any, e: any) {
    let _self = this;

    _self.filteredOptions = [];
    _self.parentFilter = {};
    _self.parentFilter['index'] = index;
    _self.parentFilter['dataValue'] =
      _self.form.data['fields'][index]['parentFilter'];

    const usecasesEntries = Object.entries(this.usecase.parentUsecases);
    const filteredUsecases = usecasesEntries
      .filter(([key, usecase]: [string, any]) => {
        if (usecase['id'] === e['code']) {
          return key;
        }
        return undefined;
      })
      .map(([key]) => key);
    _self.parseDataWithOperators();
    if (filteredUsecases[0] != undefined) {
      this.searchUsecaseAttribute(filteredUsecases[0]);
    } else {
      _self.parentUsecaseAttribute = [];
      _self.filteredOptions = [];
    }
  }

  /***
   * Search parent records with Collection Name
   */
  searchUsecaseAttribute(collection: any) {
    var _self = this;
    _self.form.searchError = false;
    _self.form.searchMessage = '';
    _self.filteredOptions = [];
    let url = _self.locator.config.get('endpoint.userstory') + '/search';
    let searchParams = {
      collectionName: collection,
    };
    this.locator.http.post(url, searchParams, function (res: any, error: any) {
      if (error) {
        return;
      }
      _self.form.searchError = !res.success;
      _self.form.searchMessage = res.result['message'];

      if (res.success) {
        let parentUsecaseId = res.result.data[0]['id'];
        _self.getParentUsecaseAttribute(parentUsecaseId);
      }
    });
  }

  public parentUsecaseAttribute = [];
  public filteredOptions = [];
  public parentFilter: any = {};
  public parsedDataWithOperators: string[] = [];

  /***
   *  Get Parent Usecase Attribut with usecaseId
   */
  public getParentUsecaseAttribute(usecaseId: Number) {
    let _self = this;
    _self.parentUsecaseAttribute = [];
    let attrUrl =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/list/' +
      usecaseId;
    _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      if (res.success) {
        _self.parentUsecaseAttribute = res.result.data;
        _self.parentUsecaseAttribute = res.result.data.filter(
          (item: any) => item.refKey !== 1,
        );
      }
    });
  }

  filterOptions() {
    let _self = this;
    const input = this.parentFilter['label'] || '';
    if (input.startsWith('@')) {
      const searchTerm = input.substring(1).toLowerCase();
      _self.filteredOptions = _self.parentUsecaseAttribute.filter(
        (option: any) => option.label.toLowerCase().includes(searchTerm),
      );
    } else {
      _self.filteredOptions = [];
    }
  }

  selectOption(option: any) {
    this.parentFilter['label'] = `@${option.label}`;
    this.parentFilter['code'] = `@${option.code}`;
    this.filteredOptions = [];
  }

  /**
   * Save Parent Filter Data
   */
  saveParentFilter() {
    const _self = this;

    // Normalize fields: default to empty strings if undefined/null
    const code = _self.parentFilter['code'] || '';
    const value = _self.parentFilter['value'] || '';
    const operator = _self.parentFilter['operator'] || '';
    let dataValue = _self.parentFilter['dataValue'] || '';

    const validOperators = _self.parsedDataWithOperators;
    const currentValue = code ? `${code}=${value}` : '';

    const prefix = code.split('=')[0] || '';

    // Check Duplicate Key
    if (
      validOperators.some(
        (op) => op.startsWith(prefix) && currentValue !== op,
      ) ||
      validOperators.includes(currentValue)
    ) {
      alert('Duplicate record cannot be added');
      return;
    }

    // Check if operator is required but not present
    if (validOperators.length > 0 && !operator) {
      alert('Please add condition first then add key value');
      return;
    }

    let finalValue = '';

    if (operator && operator !== 'undefined' && validOperators.length > 0) {
      finalValue = `${dataValue} ${operator} ${code}=${value}`;
      _self.parsedDataWithOperators.push(`${operator} ${code}=${value}`);
      _self.parentFilter['dataValue'] = finalValue;
      _self.addFeild(_self.parentFilter['index'], finalValue, 'parentFilter');
    } else {
      finalValue = `${dataValue}${code}=${value}`;
      _self.parsedDataWithOperators.push(`${code}=${value}`);
      _self.parentFilter['dataValue'] = `${code}=${value}`;
      _self.addFeild(_self.parentFilter['index'], finalValue, 'parentFilter');
    }
    _self.resetParentFilter();
  }

  /**
   * Reset Parent Filter Form But not null index and datavalue
   */
  resetParentFilter() {
    this.parentFilter = {
      code: '',
      value: '',
      operator: '',
      index: this.parentFilter['index'],
      dataValue: this.parentFilter['dataValue'],
    };
  }

  /**
   * Parse Data With Operators
   */
  parseDataWithOperators() {
    let _self = this;
    const rawValue = _self.parentFilter['dataValue'] || '';
    _self.parsedDataWithOperators = rawValue
      .split(/(\|\||&)/)
      .reduce((acc: string[], part: string, index: number, arr: string[]) => {
        part = part.trim();
        if ((part === '||' || part === '&') && index + 1 < arr.length) {
          acc.push(`${part} ${arr[index + 1].trim()}`);
          arr[index + 1] = '';
        } else if (part && part !== '||' && part !== '&') {
          acc.push(part);
        }
        return acc;
      }, []);
  }

  /**
   * Remove Parsed data list
   */
  removeSegment(index: number) {
    let _self = this;
    let length = _self.parsedDataWithOperators.length - 1;
    if (length > index && index === 0) {
      _self.parsedDataWithOperators[index + 1] = _self.parsedDataWithOperators[
        index + 1
      ].replace(/^(\|\||&)\s*/, '');
    }
    _self.parsedDataWithOperators.splice(index, 1);
    _self.parentFilter['dataValue'] = _self.parsedDataWithOperators.join(' ');
    _self.addFeild(
      this.parentFilter['index'],
      this.parentFilter['dataValue'],
      'parentFilter',
    );
    _self.parseDataWithOperators();
  }

  //------------------------------------------Draging--------------------------------------------------------

  attributeDragIndex: number | null = null;

  selectedDragAttri: any = null;

  onDragStart(event: DragEvent, value: any, index: number) {
    this.attributeDragIndex = index;
    this.selectedDragAttri = value;
    setTimeout(() => {
      (event.target as HTMLElement).classList.add('dragging');
    }, 0);
  }

  onDragOver(event: DragEvent, value: any, index: number) {
    event.preventDefault();
    if (this.attributeDragIndex === null || this.attributeDragIndex === index)
      return;
    const target = event.target as HTMLElement;
    const bounding = target.getBoundingClientRect();
    const offset = bounding.y + bounding.height / 2;
    const isAfter = event.clientY > offset;

    if (isAfter && index !== this.attributeDragIndex + 1) {
      const draggingItem = this.form.data['fields'].splice(
        this.attributeDragIndex,
        1,
      )[0];
      this.form.data['fields'].splice(index, 0, draggingItem);
      this.attributeDragIndex = index;
    } else if (!isAfter && index !== this.attributeDragIndex - 1) {
      const draggingItem = this.form.data['fields'].splice(
        this.attributeDragIndex,
        1,
      )[0];
      this.form.data['fields'].splice(index, 0, draggingItem);
      this.attributeDragIndex = index;
    }
  }

  onDrop(event: DragEvent, value: any, index: number) {
    event.preventDefault();
    if (this.attributeDragIndex !== null) {
      const finalIndex = index;
      this.moveleItem(this.attributeDragIndex, finalIndex);
      // this.moveBefore(this.attributeDragIndex , finalIndex);
    }
    this.cleanUpleDragState();
  }

  onDragEnd(event: DragEvent, item: any) {
    this.cleanUpleDragState();
  }

  private moveleItem(fromIndex: number, toIndex: number) {
    const item = this.form.data['fields'].splice(fromIndex, 1)[0];
    this.form.data['fields'].splice(toIndex, 0, item);
    this.save();
  }

  private cleanUpleDragState() {
    const draggingEl = document.querySelector('.dragging');
    if (draggingEl) draggingEl.classList.remove('dragging');
    this.attributeDragIndex = null;
    this.selectedDragAttri = null;
  }

  //------------------------------------------Draging--------------------------------------------------------

  buttonDragIndex: number | null = null;

  onDragButtonStart(event: DragEvent, btn: any, index: number) {
    this.buttonDragIndex = index;
    setTimeout(() => {
      (event.target as HTMLElement).classList.add('dragging');
    });
  }

  onDragButtonOver(event: DragEvent, index: number) {
    event.preventDefault();
    if (this.buttonDragIndex === null || this.buttonDragIndex === index) return;

    const draggingItem = this.form.data.buttons[this.buttonDragIndex];
    this.form.data.buttons.splice(this.buttonDragIndex, 1);
    this.form.data.buttons.splice(index, 0, draggingItem);
    this.buttonDragIndex = index;
  }

  onDragButtonDrop(event: DragEvent, index: number) {
    event.preventDefault();
    this.cleanUpBtnDragState();
    this.save(); // Save the updated state after drop
  }

  onDragButtonEnd(event: DragEvent) {
    this.cleanUpBtnDragState();
  }

  private cleanUpBtnDragState() {
    const draggingEl = document.querySelector('.dragging');
    if (draggingEl) draggingEl.classList.remove('dragging');
    this.buttonDragIndex = null;
  }

  //----------------------------------------------------------------------------------

  public showAttriOptions: any = [];

  public showForm: any = {};
  setShowValue(index: any, actualValue: any) {
    let _self = this;
    _self.showForm['index'] = index;
    _self.showForm['actualValue'] = actualValue;
    _self.showForm['virtualValue'];
  }

  showOptions() {
    let _self = this;
    const input = this.showForm['virtualValue'] || '';
    if (input.startsWith('@')) {
      const searchTerm = input.substring(1).toLowerCase();
      _self.showAttriOptions = _self.usecaseAttributes.filter((option: any) =>
        option.label.toLowerCase().includes(searchTerm),
      );
    } else {
      _self.filteredOptions = [];
    }
  }

  selectShowOption(option: any) {
    this.showForm['virtualValue'] = `@${option.label}`;
    this.showForm['actualValue'] = `${option.code}`;
    this.showAttriOptions = [];
  }

  //------------------------------------------Draging Section --------------------------------------------------------

  sectionDragIndex: number | null = null;
  sectionSelectedDragAttri: any = null;

  onDragStartSection(event: DragEvent, value: any, index: number) {
    this.sectionDragIndex = index;
    this.sectionSelectedDragAttri = value;

    setTimeout(() => {
      (event.target as HTMLElement).classList.add('dragging');
    }, 0);
  }

  onDragOverSection(event: DragEvent) {
    event.preventDefault(); // Necessary to allow dropping
  }

  onDropSection(event: DragEvent, value: any, dropIndex: number) {
    event.preventDefault();

    if (this.sectionDragIndex !== null && this.sectionDragIndex !== dropIndex) {
      this.moveItem(this.sectionDragIndex, dropIndex);
    }

    this.cleanUpDragState();
  }
  onDragEndSection(event: DragEvent) {
    this.cleanUpDragState();
  }

  moveItem(fromIndex: number, toIndex: number) {
    if (fromIndex < 0 || toIndex < 0 || fromIndex === toIndex) return;

    const items = this.form.data['groupLabels'];
    const item = items.splice(fromIndex, 1)[0]; // Remove from old position
    items.splice(toIndex, 0, item); // Insert at new position
    this.save();
  }

  cleanUpDragState() {
    this.sectionDragIndex = null;
    this.sectionSelectedDragAttri = null;

    document.querySelectorAll('.dragging').forEach((el) => {
      el.classList.remove('dragging');
    });
  }

  //----------------------------------------------------------------------------------------------------------------------

  showUsecaseAttributes: any[] = [];
  listOfAttributes() {
    let _self = this;
    if (_self.form.data['fields']) {
      _self.showUsecaseAttributes = _self.usecaseAttributes?.filter(
        (item: any) =>
          Array.isArray(_self.form.data['fields']) &&
          !_self.form.data['fields']?.some(
            (field: any) => field.id === item.id,
          ), // Exclude matching items
      );
    } else {
      _self.showUsecaseAttributes = _self.usecaseAttributes;
    }
  }

  buttonOptions = [
    { value: 'save', label: 'COMMON.SAVE', icon: '💾' },
    { value: 'cancel', label: 'COMMON.CANCEL', icon: '❌' },
    { value: 'delete', label: 'COMMON.DELETE', icon: '🗑️' },
    { value: 'list', label: 'COMMON.LIST', icon: '📋' },
    { value: 'custom', label: 'COMMON.CUSTOM', icon: '🛠️' },
    { value: 'new', label: 'COMMON.NEW', icon: '➕' },
  ];

  buttonList: any = [];
  selectButton() {
    let _self = this;
    _self.buttonList = _self.buttonOptions.filter(
      (item: any) =>
        Array.isArray(_self.form.data.buttons) &&
        !_self.form.data.buttons.some(
          (field: any) => field.name === item.value,
        ),
    );
  }

  public currentLabel: any = '';
  setShowValueValues(index: any, e: any) {
    let _self = this;
    _self.showForm['index'] = index;
    _self.showForm['actualValue'] = e.show;
    _self.currentLabel = e.label;
    _self.showForm['virtualValue'] = _self.revserexpression(e.show);
  }

  showOptionswhen() {
    let _self = this;
    _self.showAttriOptions = _self.usecaseAttributes.filter(
      (item: any) =>
        item.type != 'expression' && item.label != _self.currentLabel,
    );
  }

  selectShowOptionWhen(option: any) {
    this.showForm['virtualValue'] =
      this.showForm['virtualValue'] + `${option.label}`;
    this.showAttriOptions = [];
    this.canType = true;
    this.showPopup = false;
  }
  showPopup = false;
  canType = true;
  isSelectingOption = false;

  onInputChange() {
    const inputValue = this.showForm['virtualValue'];
    // Show popup when `@` is typed and no option is selected
    if (inputValue[inputValue.length - 1] === '@' && !this.isSelectingOption) {
      this.showPopup = true;
      this.canType = false;
    } else {
      this.showPopup = false;
      this.canType = true;
    }
  }
  // Close popup when input loses focus
  onBlur() {
    setTimeout(() => {
      this.showPopup = false;
    }, 200);
  }
  // Restrict invalid characters on keypress
  onKeyPress(event: KeyboardEvent) {
    if (!this.canType && event.key !== '@') {
      event.preventDefault();
      return;
    }
    // Allow backspace, delete, and arrow keys
    if (
      ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight'].includes(event.key)
    ) {
      return;
    }
    const allowedChars = /^[0-9A-Za-z+\-*/%().@<>{}[\]/^=!&|?:,'"`]+$/;
    if (!allowedChars.test(event.key)) {
      event.preventDefault();
    }
  }

  changeVitualValurToActualValuer() {
    const mappings = Object.fromEntries(
      this.usecaseAttributes?.map(
        ({ label, code }: { label: string; code: any }) => [`@${label}`, code],
      ) || [],
    );

    let data = this.showForm['virtualValue'];
    let updatedExpression = data?.replace(/@[\w\s]+/g, (match: any) => {
      return mappings[match] || match;
    });
    let checkOperator = this.findOperatorAroundText(
      this.showForm['virtualValue'],
    );
    return [checkOperator, updatedExpression];
  }

  findOperatorAroundText(expression: string): boolean {
    const mappings = Object.fromEntries(
      this.usecaseAttributes?.map(
        ({
          label,
          code,
          type,
        }: {
          label: string;
          code: string;
          type: string;
        }) => [`@${label}`, { code, type }],
      ) || [],
    );

    // Replace @labels with corresponding types
    let updatedExpression = expression.replace(/@[\w\s]+/g, (match: any) => {
      return mappings[match]?.type || match;
    });

    const regex =
      /([\-*/%<>]=?|&&|&|\?|:|,)?\s*text\s*([\-*/%<>]=?|&&|&|\?|:|,)?/g;
    let matches = [...updatedExpression.matchAll(regex)];
    for (let match of matches) {
      const beforeOperator = match[1] || null;
      const afterOperator = match[2] || null;
      if (beforeOperator || afterOperator) {
        return true;
      }
    }
    return false;
  }
  revserexpression(data: any) {
    if (!data) {
      return;
    }
    const mappings = Object.fromEntries(
      this.usecaseAttributes?.map(
        ({ code, label }: { code: any; label: string }) => [code, `@${label}`],
      ) || [],
    );

    let updatedExpression = data?.replace(/\b\w+\b/g, (match: any) => {
      return mappings[match] || match;
    });
    return updatedExpression;
  }

  addFeild1(index: any, e: any, field: any) {
    let _self = this;
    try {
      e.trim();
      let [check, expresstion] = _self.changeVitualValurToActualValuer();
      if (check == false) {
        _self.form.data['fields'][index][field] = expresstion;
        _self.save();
      } else {
        // _self.form['error'] = true;
        // _self.form['message'] = "Invalid Condition: With 'text' field, you can use only +,=,! operators."
        alert(
          "Invalid Condition: With 'text' field, you can use only +,=,! operators.",
        );
      }
    } catch (error) {
      console.error(`Error processing value for e: ${e}`, error);
    }
  }

  public getChildUscase() {
    let _self = this;

    let url =
      _self.locator.config.get('endpoint.userstory') +
      '/childlist/' +
      _self.appId +
      '/' +
      _self.usecase.collectionName;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      if (res.success) {
        const allChildUsecases = res.result['data'] || [];

        // Ensure childFormList exists (initialize if needed)
        if (!_self.form.data) {
          _self.form.data = {};
        }
        if (!_self.form.data.childFormList) {
          _self.form.data.childFormList = [];
        }

        const addedForms = _self.form.data.childFormList;

        // Extract usecaseIds from added child forms
        const addedUsecaseIds = addedForms.map((form: any) => form.userstoryId);

        // Filter usecases whose forms are NOT already added
        _self.selectChildList = allChildUsecases.filter(
          (usecase: any) => !addedUsecaseIds.includes(usecase.id),
        );

        // _self.selectChildList = res.result['data'];
      } else {
      }
    });
  }

  convertStrToNumUser(searchData: any, lebal: any) {
    if (
      searchData !== null &&
      searchData !== undefined &&
      searchData !== 'undefined'
    ) {
      this.form.searchParams[lebal] = Number(searchData);
    }
  }

  // addChildFields() {
  //   let _self = this;
  //   if (!_self.form.data?.childFormList) {
  //     _self.form.data.childFormList = [];
  //   }
  //   _self.form.data['childFormList'].push(_self.selectedChildForm);
  //   _self.save();
  // }
  addChildFields() {
    if (
      !this.selectedChildForm ||
      typeof this.selectedChildForm !== 'object' ||
      !this.selectedChildForm.id
    ) {
      alert('Please select a valid child form field');
      return;
    }

    // Check if selection is valid
    if (!this.selectedChildForm || !this.selectedChildForm.id) {
      console.log('this is selected child form', this.selectedChildForm);
      console.log('this is selected child form', this.selectedChildForm.id);
      alert('Please select a valid child form field');
      return;
    }

    if (!this.form.data?.childFormList) {
      this.form.data.childFormList = [];
    }

    const isDuplicate = this.form.data.childFormList.some(
      (child: any) => child.id === this.selectedChildForm.id,
    );

    if (!isDuplicate) {
      this.form.data.childFormList.push(this.selectedChildForm);
      this.save();

      this.getChildUscase();
      //  Immediately filter form dropdown
      const addedFormIds = this.form.data.childFormList.map((f: any) => f.id);
      this.selectChildFormList = this.selectChildFormList.filter(
        (f: any) => !addedFormIds.includes(f.id),
      );

      //  Reset both dropdowns
      this.selectedChildUsecase = undefined;
      this.selectedChildForm = undefined;
    } else {
      console.log('Duplicate child form not added');
      // Optional: show a message to user
    }
  }

  async deleteChildFields(index: any) {
    let _self = this;
    const confirmAsync = () =>
      new Promise((resolve) => {
        const flag = confirm('Are you sure ?');
        resolve(flag);
      });

    const flag = await confirmAsync();
    if (!flag) {
      return;
    }

    if (
      _self.form.data['childFormList'] &&
      _self.form.data['childFormList'].length
    ) {
      // Remove the group label and save changes asynchronously
      _self.form.data['childFormList'].splice(index, 1);

      if (_self.save && typeof _self.save === 'function') {
        try {
          _self.save(); // Ensure save is awaited
          console.log(
            'Child Form list deleted and changes saved successfully.',
          );
        } catch (error) {
          console.error('Error saving changes:', error);
        }
      }
    }
    //  Now that form.childFormList is populated, we can filter child usecases
    this.getChildUscase();
  }

  //------------------------------------------Draging--------------------------------------------------------

  attributeChildDragIndex: number | null = null;

  onDragchildStart(event: DragEvent, value: any, index: number) {
    this.attributeChildDragIndex = index;
    setTimeout(() => {
      (event.target as HTMLElement).classList.add('dragging');
    }, 0);
  }

  onDragchildOver(event: DragEvent, value: any, index: number) {
    event.preventDefault();
    if (
      this.attributeChildDragIndex === null ||
      this.attributeChildDragIndex === index
    )
      return;
    const target = event.target as HTMLElement;
    const bounding = target.getBoundingClientRect();
    const offset = bounding.y + bounding.height / 2;
    const isAfter = event.clientY > offset;

    if (isAfter && index !== this.attributeChildDragIndex + 1) {
      const draggingItem = this.form.data['childFormList'].splice(
        this.attributeChildDragIndex,
        1,
      )[0];
      this.form.data['childFormList'].splice(index, 0, draggingItem);
      this.attributeChildDragIndex = index;
    } else if (!isAfter && index !== this.attributeChildDragIndex - 1) {
      const draggingItem = this.form.data['childFormList'].splice(
        this.attributeChildDragIndex,
        1,
      )[0];
      this.form.data['childFormList'].splice(index, 0, draggingItem);
      this.attributeChildDragIndex = index;
    }
  }

  onchildDrop(event: DragEvent, value: any, index: number) {
    event.preventDefault();
    if (this.attributeChildDragIndex !== null) {
      const finalIndex = index;
      this.movelechildItem(this.attributeChildDragIndex, finalIndex);
      // this.moveBefore(this.attributeChildDragIndex , finalIndex);
    }
    this.cleanUpleChildDragState();
  }

  onDragchildEnd(event: DragEvent, item: any) {
    this.cleanUpleChildDragState();
  }

  private movelechildItem(fromIndex: number, toIndex: number) {
    const item = this.form.data['childFormList'].splice(fromIndex, 1)[0];
    this.form.data['childFormList'].splice(toIndex, 0, item);
    this.save();
  }

  private cleanUpleChildDragState() {
    const draggingEl = document.querySelector('.dragging');
    if (draggingEl) draggingEl.classList.remove('dragging');
    this.attributeChildDragIndex = null;
  }

  ruleData: any = {
    data: {},
    error: false,
    message: '',
    success: false,
  };

  resetRuleDataForm() {
    this.ruleData = {
      data: {},
      error: false,
      message: '',
      success: false,
    };
  }

  formName: any;
  getFormId(e: any) {
    this.formId = e.id;
    this.getRules();

    this.formName = [e.applicationName, e.userstoryName]
      .filter((val) => !!val)
      .join(' ');
  }

  addRuleWithText() {
    let _self = this;

    _self.ruleData.data['formId'] = _self.formId;
    _self.ruleData.data['name'] = this.formName + _self.ruleData.data['event'];

    // Get current rule id if editing (could be undefined/null if adding new)
    let currentRuleId = _self.ruleData.data['id'] || null;

    // Check duplicate ignoring current rule id
    let isDuplicate = _self.ruleList.some(
      (item: any) =>
        item.name === _self.ruleData.data['name'] && item.id !== currentRuleId,
    );

    if (isDuplicate) {
      _self.ruleData.error = true;
      _self.ruleData.message = 'Duplicate event not allowed';
      return;
    }

    _self.locator.config
      .getProperty('endpoint.application.rules')
      .then((property: string) => {
        let url = property + '/save';

        _self.locator.http.post(
          url,
          _self.ruleData.data,
          function (res: any, error: any) {
            if (error) return;

            _self.ruleData.error = !res.success;

            // Refresh list on success
            if (res.success) {
              _self.ruleData.message = true;
              _self.ruleData.message = 'Rule saved successfully';
              _self.getRules();
              // (_self as any).resetRuleDataForm();
            } else {
              _self.ruleData.message = false;
              _self.ruleData.message = res.message || 'Error while saving rule';
            }
          },
        );
      });
  }

  getRule(id: any, callback?: () => void) {
    let _self = this;

    _self.locator.config
      .getProperty('endpoint.application.rules')
      .then((property: string) => {
        let url = property + '/get/' + id;

        _self.locator.http.get(url, function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            return;
          }

          const result = res.result?.data;
          if (!result) {
            console.error('No data returned for rule');
            return;
          }

          _self.ruleData = { data: result };       

          if (callback) callback();
        });
      });
  }
  openRuleEditModal(id: any) {
    this.getRule(id, () => {
      const modal = new bootstrap.Modal(document.getElementById('addRule')!);
      modal.show();
    });
  }
  deleteRule(id: any) {
    let _self = this;
    if (!confirm('Are you sure you want to delete this rule?')) return;

    _self.locator.config
      .getProperty('endpoint.application.rules')
      .then((property: string) => {
        let url = property + `/delete/${id}`;

        _self.locator.http.get(url, function (res: any, error: any) {
          if (error) {
            alert('Delete failed: ' + error);
            return;
          }

          _self.ruleData.message = 'Rule deleted successfully';
          _self.ruleData.success = true;
          _self.getRules();
        });
      });
  }
  // In your component.ts file
  getRuleEvents() {
    return [
      { value: 'beforeSubmit', label: 'RULES.EVENTS.BEFORE_SUBMIT' },
      { value: 'afterSubmit', label: 'RULES.EVENTS.AFTER_SUBMIT' },
      { value: 'beforeInsert', label: 'RULES.EVENTS.BEFORE_INSERT' },
      { value: 'afterInsert', label: 'RULES.EVENTS.AFTER_INSERT' },
      { value: 'beforeUpdate', label: 'RULES.EVENTS.BEFORE_UPDATE' },
      { value: 'afterUpdate', label: 'RULES.EVENTS.AFTER_UPDATE' },
      { value: 'beforeDelete', label: 'RULES.EVENTS.BEFORE_DELETE' },
      { value: 'afterDelete', label: 'RULES.EVENTS.AFTER_DELETE' },
      { value: 'onAdd', label: 'RULES.EVENTS.ON_ADD' },
    ];
  }
  getEventTranslation(eventKey: string): string {
    const eventTranslations: { [key: string]: string } = {
      beforeSubmit: 'RULES.EVENTS.BEFORE_SUBMIT',
      afterSubmit: 'RULES.EVENTS.AFTER_SUBMIT',
      beforeInsert: 'RULES.EVENTS.BEFORE_INSERT',
      afterInsert: 'RULES.EVENTS.AFTER_INSERT',
      beforeUpdate: 'RULES.EVENTS.BEFORE_UPDATE',
      afterUpdate: 'RULES.EVENTS.AFTER_UPDATE',
      beforeDelete: 'RULES.EVENTS.BEFORE_DELETE',
      afterDelete: 'RULES.EVENTS.AFTER_DELETE',
      onAdd: 'RULES.EVENTS.ON_ADD',
    };
    return eventTranslations[eventKey] || eventKey;
  }
  // Add this ONE line to your existing properties
  selectedEditItemId: string | null = null;

  displayFn(option: any): string {
    return option && option.label ? option.label : '';
  }

// Custom Button Form - Temporary form for modal only
public customButtonForm: any = {
  name: '',
  actionType: null, 
  formId: undefined,
  reportId: undefined,
  url: '',  
  openInNewTab: false, 
  error: false,
    message: '',
};

// Report List (you'll need to fetch this from your API)
  public reportList: any[] = [];
  public formList: any[] = [];

/**
 * Open custom button configuration modal
 */
openCustomButtonModal() {
  this.resetCustomButtonForm();
  this.loadReportList();
  this.loadFormList();
    const modal = new bootstrap.Modal(
      document.getElementById('customButtonModal')!,
    );
  modal.show();
}

/**
 * Reset custom button form
 */
resetCustomButtonForm() {
  this.customButtonForm = {
    name: '',
    actionType: null,
    formId: undefined,
    reportId: undefined,
    url: '',   
    openInNewTab: false, 
    error: false,
      message: '',
  };
}

/**
 * Handle action type change - clear other selections
 */
onActionTypeChange() {
  const actionType = this.customButtonForm.actionType;
  
  // Clear form selection if not form type
  if (actionType !== 'form') {
    this.customButtonForm.formId = undefined;
  }
  
  // Clear report selection if not report type
  if (actionType !== 'report') {
    this.customButtonForm.reportId = undefined;
  }
  
  // Clear URL fields if not url type
  if (actionType !== 'url') {
    this.customButtonForm.url = '';
    this.customButtonForm.urlTarget = '_self';
  }
}

/**
 * Validate custom button form
 */
isCustomButtonValid(): boolean {
  // Name is always required
    if (
      !this.customButtonForm.name ||
      this.customButtonForm.name.trim() === ''
    ) {
    return false;
  }
  
  // Action type is required
  if (!this.customButtonForm.actionType) {
    return false;
  }
  
  // Validate based on action type
  switch (this.customButtonForm.actionType) {
    case 'form':
        return (
          this.customButtonForm.formId !== undefined &&
          this.customButtonForm.formId !== null
        );
    
    case 'report':
        return (
          this.customButtonForm.reportId !== undefined &&
          this.customButtonForm.reportId !== null
        );
    
    case 'url':
        return (
          this.customButtonForm.url && this.customButtonForm.url.trim() !== ''
        );
    
    default:
      return false;
  }
}

/**
 * Save custom button - stores ONLY name and url (no extra info about type)
 */
saveCustomButton() {
  let _self = this;
  
  if (!this.isCustomButtonValid()) {
    _self.customButtonForm.error = true;
    _self.customButtonForm.message = 'Please fill all required fields';
    return;
  }
  
  if (!_self.form.data.buttons || !Array.isArray(_self.form.data.buttons)) {
    _self.form.data.buttons = [];
  }
  
  // Check for duplicate button name
  const exists = _self.form.data.buttons.find(
      (button: any) => button.name === _self.customButtonForm.name,
  );
  
  if (exists) {
    _self.customButtonForm.error = true;
    _self.customButtonForm.message = 'A button with this name already exists';
    return;
  }
  
  // Simple URL based on action type - no encoding, just the actual URL
  let buttonUrl = '@';   

  switch (_self.customButtonForm.actionType) {
    case 'form':
        console.log(_self.customButtonForm.formId);
      const selectedForm = _self.formList.find(
          (f: any) => f.id === _self.customButtonForm.formId,
      );
     
      if (selectedForm) {
        buttonUrl = `uiformlist/${selectedForm.id}`;
      }

      _self.form.data.buttons.push({
        name: _self.customButtonForm.name,
        url: buttonUrl,
          type: 'form',
      });
      break;

    case 'report':
      const selectedReport = _self.reportList.find(
          (r: any) => r.id === _self.customButtonForm.reportId,
      );

      if (selectedReport) {
        buttonUrl = `reportslist/${_self.appId}/${selectedReport.id}`;
      }

      _self.form.data.buttons.push({
        name: _self.customButtonForm.name,
        url: buttonUrl,
          type: 'report',
      });
      break;
    
    case 'url':
      // Just use the URL as-is, no extra encoding
      buttonUrl = _self.customButtonForm.url;
      _self.form.data.buttons.push({
        name: _self.customButtonForm.name,
        url: buttonUrl,
        target: _self.customButtonForm.openInNewTab ? '_blank' : '_self',
          type: 'url',
      });
      break;
  }
  
  // Save form
  _self.save();
  
  // Close modal
  const modalElement = document.getElementById('customButtonModal');
  const modal = bootstrap.Modal.getInstance(modalElement!);
  modal?.hide();
  
  // Reset selected button
  setTimeout(() => {
    _self.selectedButton = '0';
  }, 0);
  
  // Success message
  _self.customButtonForm.error = false;
  _self.customButtonForm.message = 'Custom button added successfully';
}

loadReportList() {
  let _self = this;
  if (!_self.appId) return;

  this.locator.config
    .getProperty('endpoint.reports')
    .then((property: string) => {
      const fetchPage = (page: number, accumulatedData: any[] = []) => {
        let url = property + '/search/' + page;

          _self.locator.http.post(
            url,
            { applicationId: Number(_self.appId) },
            function (res: any, error: any) {
          if (error) return;

          if (res.success) {
                const allData = [
                  ...accumulatedData,
                  ...(res.result.data || []),
                ];
            const pageCount = res.result.pageCount || 1;

            if (page + 1 < pageCount) {
              fetchPage(page + 1, allData); 
            } else {
              _self.reportList = allData;  
            }
          }
            },
          );
      };

      fetchPage(0); 
    });
}

loadFormList() {
  let _self = this;
  if (!_self.appId) return;

  this.locator.config
    .getProperty('endpoint.ui.forms')
    .then((property: string) => {
      const fetchPage = (page: number, accumulatedData: any[] = []) => {
        let url = property + '/searchform/' + page;

          _self.locator.http.post(
            url,
            { appId: Number(_self.appId) },
            function (res: any, error: any) {
          if (error) return;

          if (res.success) {
                const allData = [
                  ...accumulatedData,
                  ...(res.result.data || []),
                ];
            const pageCount = res.result.pageCount || 1;

            if (page + 1 < pageCount) {
              fetchPage(page + 1, allData); 
            } else {
              _self.formList = allData;
            }
          }
            },
          );
      };

      fetchPage(0); 
    });
}
}
